import { render } from "./Policies.vue?vue&type=template&id=277b755b&scoped=true"
import script from "./Policies.vue?vue&type=script&lang=js"
export * from "./Policies.vue?vue&type=script&lang=js"

import "./Policies.vue?vue&type=style&index=0&id=277b755b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-277b755b"]])

export default __exports__